export default "__VITE_ASSET__81197a86__"